// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @13.12.2018 15:04:16
import { RbacAccessObject_abstract } from './../../abstract/SagaBase/RBAC/RbacAccessObject_abstract';
export class RbacAccessObject extends RbacAccessObject_abstract {}
